import React from 'react'
import MainNav from './mainNav'
import MobileNav from './mobileNav'

const NavWrapper = () => {
    return (
        <>
            <MobileNav />
            <MainNav />
        </>
    )
}

export default NavWrapper